<div *ngIf="errorBelowInput || errorAboveInput" class="above-wrapper">
  <span
    class="placeholder"
    [class.error]="control?.invalid && inputComponent?.submitted"
    [class.focus]="isFocused || element.nativeElement.value !== ''"
    #placeholderEL
  >
    <span *ngIf="units === 'weight' || units === 'length' || units === 'weightT'; else withoutUnits">
      {{ placeholder | translate | unit: units:true }}
    </span>
    <ng-template #withoutUnits>
      {{ placeholder | translate }}
    </ng-template>
  </span>
  <gl-error
    *ngIf="isErrorVisible || (inputComponent?.submitted && control?.invalid)"
    data-ctx="error"
    [class.error-above-input]="errorAboveInput"
    [message]="getErrorObjectFirstTranslationKey()"
  ></gl-error>
</div>
<div
  class="input-wrapper"
  [class.error]="
    (control?.invalid && inputComponent?.submitted) || (!!rawFieldError && inputComponent?.submitted)
  "
>
  <div class="input-container" data-ctx="inputContainer">
    <span
      *ngIf="!errorBelowInput && !errorAboveInput"
      class="placeholder"
      [class.error]="
        (control?.invalid && inputComponent?.submitted) || (!!rawFieldError && inputComponent?.submitted)
      "
      [class.focus]="isFocused || element.nativeElement.value !== ''"
      #placeholderEL
    >
      <span *ngIf="units === 'weight' || units === 'length' || units === 'weightT'; else withoutUnits">
        {{ placeholder | translate | unit: units:true }}
      </span>
      <ng-template #withoutUnits>
        {{ placeholder | translate }}
      </ng-template>
    </span>

    <div class="content">
      <div (click)="minusSignHandler()" [class.hidden]="isDisabled" class="sign">-</div>
      <ng-content></ng-content>
      <div (click)="plusSignHandler()" [class.hidden]="isDisabled" class="sign">+</div>
    </div>
  </div>

  <div (click)="changeTypeOnPasswordInput()" class="eye-container">
    <gl-icon [name]="'eye'" *ngIf="wasPassedAsPasswordType && !isPasswordType"></gl-icon>
    <gl-icon [name]="'eye-closed'" *ngIf="wasPassedAsPasswordType && isPasswordType"></gl-icon>
  </div>

  <div
    class="error-icon"
    [ngClass]="{ up: !placeholder }"
    #errorIcon
    [hidden]="!showErrorIcon()"
    [glTooltip]="getTooltipErrorText()"
    [isError]="true"
    [position]="'top'"
    [messageValue]="messageValue"
  >
    !
  </div>
</div>
